import React, { useState, useEffect } from 'react';
import {
    Card,
    CardContent,
    Grid,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Box,
    Paper,
    Autocomplete,
    Tabs,
    Tab,
    Alert,
    CircularProgress,
    Modal,
    IconButton,
    Checkbox,             // 👈 nuevo
    FormControlLabel,     // 👈 nuevo
    FormGroup,            // 👈 nuevo
    Radio,
    RadioGroup,
   
} from '@mui/material';
import {
    Print as PrintIcon,
    Description as DescriptionIcon,
    Assessment as AssessmentIcon,
    Close as CloseIcon,
    Download as DownloadIcon,
    Balance,
    Money,
    MoneyOffCsred,
    MoneyRounded,
    MoneySharp,
    MoneyOffCsredOutlined,
    InsertDriveFile as InsertDriveFileIcon
} from '@mui/icons-material';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import Resultados from '../Cotizaciones/Resultados';
import { useAccesos } from '../contexts/AccesosContext';

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

function InformesFinancieros() {
    const server = process.env.REACT_APP_API_ROUTE;
    const { user } = useUser();
    const { tienePermiso } = useAccesos();

    // Estados generales
    const [tabValue, setTabValue] = useState(0);
    const [loading, setLoading] = useState(false);
    const [empresas, setEmpresas] = useState([]);
    const [cuentas, setCuentas] = useState([]);
    const [cuentasMayor, setCuentasMayor] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [sucursalesFiltradas, setSucursalesFiltradas] = useState([]);   
    const [unidaddenegocio, setUnidaddeNegocio] = useState([]);
    

    // Estados para Reporte de Asientos
    const [idEmpresaAsientos, setIdEmpresaAsientos] = useState(null);
    const [fechaInicioAsientos, setFechaInicioAsientos] = useState('');
    const [fechaFinAsientos, setFechaFinAsientos] = useState('');

    // Estados para Libro Mayor
    const [codigoCuentaMayor, setCodigoCuentaMayor] = useState(null);
    const [idCuentaMayor, setIdCuentaMayor] = useState(null);
    const [fechaInicioMayor, setFechaInicioMayor] = useState('');
    const [fechaFinMayor, setFechaFinMayor] = useState('');

    //Estados para reporte Balance General
    const[idEmpresaBalance, setIdEmpresaBalance] = useState(null);
    const[fechaInicioBalance, setFechaInicioBalance] = useState('');
    const[fechafinBalance, setFechaFinBalance] = useState('');

    // Solo un radio controla todo
    //   const [nivel3Selected, setNivel3Selected] = useState(true); // o en false si quieres por defecto


        // 👇 NUEVO: estados de niveles para el Estado de Situación Financiera
        const [nivelesBalance, setNivelesBalance] = useState({
            Nivel1: true,
            Nivel2: true,
            Nivel3: true,
            Nivel4: true,
            Detalle: true
        });

        const [nivelesEstadoResultado, setNivelesEstadoResultado] = useState({
            Nivel1: true,
            Nivel2: true,
            Nivel3: true,
            Nivel4: true,
            Detalle: true
        });

        const [repetirencabezado, setRepetirEncabezado] = useState({

            Valor:true,
           
        });
    //Estados para reporte Balanza de Comprobación
    const[idEmpresaBalanza, setIdEmpresaBalanza] = useState(null);
    const[fechaInicioBalanza, setFechaInicioBalanza] = useState('');
    const[fechaFinBalanza, setFechaFinBalanza] = useState('');

    // Estados para el modal de visualización PDF
    const [openModal, setOpenModal] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [pdfNombre, setPdfNombre] = useState('');
    const [tipoReporte, setTipoReporte] = useState(''); // 'asientos', 'libromayor', 'balanza', 'balance', 'estadoresultado'

    // Estados de Unidad de negocio y Sucursales
      
    const[idEmpresaEstadoresultado, setidEmpresaEstadoresultado] = useState(null);
    const[fechaInicioEstadoresultado,  setfechaInicioEstadoresultado] = useState('');
    const[fechafinEstadoresultado, setfechafinEstadoresultado] = useState('');
    const[idSucursales, setIdSucursales] = useState(null);
    const[idunidadNegocio, setIdUnidadNegocio] = useState(null);



    useEffect(() => {
        cargarEmpresas();
        cargarCuentas();
        cargarSucursales();
        cargarUnidadesdeNegocio();
        //Agregando los combos de Sucursal y Unidad de Negocio
    }, []);

    // Filtrar sucursales cuando cambie la empresa seleccionada
    useEffect(() => {
        if (idEmpresaEstadoresultado && sucursales.length > 0) {
            const sucursalesDeLaEmpresa = sucursales.filter(
                sucursal => sucursal.idEmpresa === idEmpresaEstadoresultado.idEmpresa
            );
            setSucursalesFiltradas(sucursalesDeLaEmpresa);
            
            // Resetear la sucursal seleccionada y seleccionar la primera de la nueva empresa
            if (sucursalesDeLaEmpresa.length > 0) {
                setIdSucursales(sucursalesDeLaEmpresa[0]);
            } else {
                setIdSucursales(null);
            }
        } else {
            setSucursalesFiltradas([]);
            setIdSucursales(null);
        }
    }, [idEmpresaEstadoresultado, sucursales]);

    // Limpiar URL del PDF al cerrar modal
    useEffect(() => {
        if (!openModal && pdfUrl) {
            window.URL.revokeObjectURL(pdfUrl);
            setPdfUrl('');
        }
    }, [openModal]);

    // Cargar empresas
    const cargarEmpresas = async () => {
        try {
            const response = await fetch(`${server}/MgEmpresas`);
            if (response.ok) {
                const data = await response.json();
                const empresasArray = data.$values || data || [];
                setEmpresas(empresasArray);
                
                // Seleccionar la primera empresa por defecto
                if (empresasArray.length > 0) {
                    setIdEmpresaAsientos(empresasArray[0]);
                    setIdEmpresaBalance(empresasArray[0]);
                    setidEmpresaEstadoresultado(empresasArray[0]);
                }
            }
        } catch (error) {
            console.error('Error al cargar empresas:', error);
            Swal.fire('Error', 'No se pudieron cargar las empresas', 'error');
        }
    };

    // Cargar cuentas contables
    const cargarCuentas = async () => {
        try {
            const response = await fetch(`${server}/CtbPlanDeCuentas`);
            if (response.ok) {
                const data = await response.json();
                const cuentasArray = data.$values || data || [];
                setCuentas(cuentasArray);

                // Filtrar solo cuentas de detalle (nivel 5 - las que aceptan movimientos)
                const cuentasMayorFiltradas = cuentasArray.filter(
                    cuenta => cuenta.nivel === 5 && cuenta.aceptaMovimientos === true
                );
                
                console.log('📊 Cuentas cargadas:', {
                    total: cuentasArray.length,
                    cuentasDetalle: cuentasMayorFiltradas.length,
                    muestra: cuentasMayorFiltradas.slice(0, 3).map(c => ({
                        codigo: c.codigo,
                        descripcion: c.descripcion,
                        nivel: c.nivel,
                        aceptaMovimientos: c.aceptaMovimientos
                    }))
                });
                
                setCuentasMayor(cuentasMayorFiltradas);
            }
        } catch (error) {
            console.error('Error al cargar cuentas:', error);
            Swal.fire('Error', 'No se pudieron cargar las cuentas contables', 'error');
        }
    };
    // Agregamos la traida de los catalogos de Unidad de Negocio y Sucursal //
    const cargarSucursales = async () => {
        try {
            const response = await fetch(`${server}/MgSucursales`);
            if (response.ok) {
                const data = await response.json();
                const sucursalesarray = data.$values || data || [];
                console.log('✅ Sucursales cargadas:', sucursalesarray);
                setSucursales(sucursalesarray);
                // No seleccionar por defecto, se hará en el useEffect de filtrado
            }
        } catch (error) {
            console.error('Error al cargar Sucursales:', error);
            Swal.fire('Error', 'No se pudieron cargar las sucursales', 'error');
        }
        
        
        
        
        
        /*try {
            const [unidadesRes, sucursalesRes] = await Promise.all([
                fetch(`${server}/CtbUnidadNegocios`, { headers: { 'Authorization': `Bearer ${user?.token}` } }),
                fetch(`${server}/MgSucursales`, { headers: { 'Authorization': `Bearer ${user?.token}` } })
               
            ]);

            const [unidadesData, sucursalesData] = await Promise.all([
                unidadesRes.json(),
                sucursalesRes.json(),
               
            ]);

            setUnidadesNegocio(unidadesData.$values || unidadesData || []);
            setSucursales(sucursalesData.$values || sucursalesData || []);
          
        } catch (error) {
            console.error('Error al cargar catálogos:', error);
        }*/
    };
     const cargarUnidadesdeNegocio = async () => {
        
         try {
            const response = await fetch(`${server}/CtbUnidadNegocios`);
            if (response.ok) {
                const data = await response.json();
                const unidadesnegocioarray = data.$values || data || [];
                setUnidaddeNegocio(unidadesnegocioarray);
                
                // Seleccionar la primera Uniudad de negocio por defecto por defecto
                if (unidadesnegocioarray.length > 0) {
                    setIdUnidadNegocio(unidadesnegocioarray[0]);
                    
                }
            }
        } catch (error) {
            console.error('Error al cargar Sucursales:', error);
            Swal.fire('Error', 'No se pudieron las Unidades de Negocio', 'error');
        }
        
    };

    // Cambiar tab
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // Generar Reporte de Asientos
    const generarReporteAsientos = async () => {
        // Validaciones
        if (!idEmpresaAsientos) {
            Swal.fire('Validación', 'Debe seleccionar una empresa', 'warning');
            return;
        }
        if (!fechaInicioAsientos || !fechaFinAsientos) {
            Swal.fire('Validación', 'Debe ingresar las fechas de inicio y fin', 'warning');
            return;
        }

        // Convertir fechas a formato YYYYMMDD
        const f1 = fechaInicioAsientos.replace(/-/g, '');
        const f2 = fechaFinAsientos.replace(/-/g, '');

        setLoading(true);
        try {
            const url = `${server}/InformesContablesLinux/asientos/${idEmpresaAsientos.idEmpresa}/${f1}/${f2}/ReportAsiento`;
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/pdf'
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const urlBlob = window.URL.createObjectURL(blob);
                
                // Configurar y abrir modal con el PDF
                const nombreArchivo = `Reporte_Asientos_${idEmpresaAsientos.nombreCompleto}_${f1}_${f2}.pdf`;
                setPdfUrl(urlBlob);
                setPdfNombre(nombreArchivo);
                setTipoReporte('asientos');
                setOpenModal(true);

                Swal.fire('Éxito', 'Reporte de asientos generado correctamente', 'success');
            } else {
                throw new Error('Error al generar el reporte');
            }
        } catch (error) {
            console.error('Error al generar reporte de asientos:', error);
            Swal.fire('Error', 'No se pudo generar el reporte de asientos', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Generar Libro Mayor
    const generarLibroMayor = async () => {
        // Validaciones
        if (!codigoCuentaMayor) {
            Swal.fire('Validación', 'Debe seleccionar una cuenta de mayor', 'warning');
            return;
        }
        if (!idCuentaMayor) {
            Swal.fire('Validación', 'Debe seleccionar una cuenta válida', 'warning');
            return;
        }
        if (!fechaInicioMayor || !fechaFinMayor) {
            Swal.fire('Validación', 'Debe ingresar las fechas de inicio y fin', 'warning');
            return;
        }

        // Convertir fechas a formato YYYYMMDD
        const f1 = fechaInicioMayor.replace(/-/g, '');
        const f2 = fechaFinMayor.replace(/-/g, '');
        const repetir = repetirencabezado.Valor ? 'true' : 'false';

        setLoading(true);
        try {
            const url = `${server}/InformesContablesLinux/libromayor/${codigoCuentaMayor}/${idCuentaMayor}/${f1}/${f2}/${repetir}/ReportLibroMayor`;
            console.log('Url libro mayor:', url);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/pdf'
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const urlBlob = window.URL.createObjectURL(blob);
                
                // Configurar y abrir modal con el PDF
                const nombreArchivo = `Libro_Mayor_${codigoCuentaMayor}_${f1}_${f2}.pdf`;
                setPdfUrl(urlBlob);
                setPdfNombre(nombreArchivo);
                setTipoReporte('libromayor');
                setOpenModal(true);

                Swal.fire('Éxito', 'Libro mayor generado correctamente', 'success');
            } else {
                throw new Error('Error al generar el libro mayor');
            }
        } catch (error) {
            console.error('Error al generar libro mayor:', error);
            Swal.fire('Error', 'No se pudo generar el libro mayor', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Generar reporte de Estado de Situación Financiera
    const generarBalanceGeneral = async () => {
        // Validaciones
        if (!idEmpresaBalance) {
            Swal.fire('Validación', 'Debe seleccionar una empresa', 'warning');
            return;
        }
        if (!fechaInicioBalance || !fechafinBalance) {
            Swal.fire('Validación', 'Debe ingresar las fechas de inicio y fin', 'warning');
            return;
        }

        // Convertir fechas a formato YYYYMMDD
        const f1 = fechaInicioBalance.replace(/-/g, '');
        const f2 = fechafinBalance.replace(/-/g, '');

        // 👇 Construir objeto de niveles desde el estado
        const niveles = {
            Nivel1: nivelesBalance.Nivel1,
            Nivel2: nivelesBalance.Nivel2,
            Nivel3: nivelesBalance.Nivel3,
            Nivel4: nivelesBalance.Nivel4,
            Detalle: nivelesBalance.Detalle
        };

        // Pasar el objeto como JSON en el query param `niveles`
        const nivelesString = JSON.stringify(niveles);
        const nivelesEncoded = encodeURIComponent(nivelesString);

        setLoading(true);
        try {
            const url = `${server}/InformesContablesLinux/balancegeneral/${idEmpresaBalance.idEmpresa}/${f1}/${f2}/ReportBalanceGeneral?niveles=${nivelesEncoded}`;
            console.log('Url balance general:', url);

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/pdf'
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const urlBlob = window.URL.createObjectURL(blob);
                
                const nombreArchivo = `Reporte_BalanceGeneral_${idEmpresaBalance.nombreCompleto}_${f1}_${f2}.pdf`;
                setPdfUrl(urlBlob);
                setPdfNombre(nombreArchivo);
                setTipoReporte('balance');
                setOpenModal(true);

                Swal.fire('Éxito', 'Reporte de balance general generado correctamente', 'success');
            } else {
                throw new Error('Error al generar el reporte');
            }
        } catch (error) {
            console.error('Error al generar reporte de Estado de Situación Financiera:', error);
            Swal.fire('Error', 'No se pudo generar el reporte de Estado de Situación Financiera', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Generar Balanza de Comprobación
    const generarBalanzaComprobacion = async () => {
        // Validaciones
        if (!idEmpresaBalanza) {
            Swal.fire('Validación', 'Debe seleccionar una empresa', 'warning');
            return;
        }
        if (!fechaInicioBalanza || !fechaFinBalanza) {
            Swal.fire('Validación', 'Debe ingresar las fechas de inicio y fin', 'warning');
            return;
        }

        // Convertir fechas a formato YYYYMMDD
        const f1 = fechaInicioBalanza.replace(/-/g, '');
        const f2 = fechaFinBalanza.replace(/-/g, '');

        setLoading(true);
        try {
            const url = `${server}/InformesContablesLinux/balanzacomprobacion/${idEmpresaBalanza.idEmpresa}/${f1}/${f2}/ReportBalanzaComprobacion`;
            
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/pdf'
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const urlBlob = window.URL.createObjectURL(blob);
                
                // Configurar y abrir modal con el PDF
                const nombreArchivo = `Balanza_Comprobacion_${idEmpresaBalanza.nombreCompleto}_${f1}_${f2}.pdf`;
                setPdfUrl(urlBlob);
                setPdfNombre(nombreArchivo);
                setTipoReporte('balanza');
                setOpenModal(true);

                Swal.fire('Éxito', 'Balanza de comprobación generada correctamente', 'success');
            } else {
                throw new Error('Error al generar el reporte');
            }
        } catch (error) {
            console.error('Error al generar Balanza de Comprobación:', error);
            Swal.fire(
                'Error',
                'No se pudo generar la balanza de comprobación. Es posible que el servidor esté presentando problemas. Intente más tarde o contacte al administrador.',
                'error'
            );
        } finally {
            setLoading(false);
        }
    };

    //Generar Estado de Resultado
     const generarEstadoResultado = async () => {
        // Validaciones
        if (!idEmpresaEstadoresultado) {
            Swal.fire('Validación', 'Debe seleccionar una empresa', 'warning');
            return;
        }
        if (!idSucursales) {
            Swal.fire('Validación', 'Debe seleccionar una sucursal', 'warning');
            return;
        }
        if (!idunidadNegocio) {
            Swal.fire('Validación', 'Debe seleccionar una unidad de negocio', 'warning');
            return;
        }
        if (!fechaInicioEstadoresultado || !fechafinEstadoresultado) {
            Swal.fire('Validación', 'Debe ingresar las fechas de inicio y fin', 'warning');
            return;
        }

        // Validar que los objetos tengan los IDs necesarios
        const sucursalId = idSucursales?.idSucursal || idSucursales?.id || idSucursales?.ID;
        const unidadId = idunidadNegocio?.idUnidadNegocio || idunidadNegocio?.id || idunidadNegocio?.ID;
        
        if (!sucursalId) {
            Swal.fire('Validación', 'La sucursal seleccionada no tiene un ID válido', 'warning');
            return;
        }
        
        if (!unidadId) {
            Swal.fire('Validación', 'La unidad de negocio seleccionada no tiene un ID válido', 'warning');
            return;
        }

        // Convertir fechas a formato YYYYMMDD
        const f1 = fechaInicioEstadoresultado.replace(/-/g, '');
        const f2 = fechafinEstadoresultado.replace(/-/g, '');

        setLoading(true);
        try {
            // Debug: verificar los objetos seleccionados
            console.log('🔍 Debug objetos seleccionados:', {
                empresa: idEmpresaEstadoresultado,
                sucursal: idSucursales,
                unidadNegocio: idunidadNegocio,
                sucursalId,
                unidadId
            });

            // Construir niveles desde el estado
            const niveles = {
                Nivel1: nivelesEstadoResultado.Nivel1,
                Nivel2: nivelesEstadoResultado.Nivel2,
                Nivel3: nivelesEstadoResultado.Nivel3,
                Nivel4: nivelesEstadoResultado.Nivel4,
                Detalle: nivelesEstadoResultado.Detalle
            };
            const nivelesString = JSON.stringify(niveles);
            const nivelesEncoded = encodeURIComponent(nivelesString);

            // Construir URL con todos los parámetros en la ruta, repetirEncabezado y niveles
            const url = `${server}/InformesContablesLinux/estadoresultado/${idEmpresaEstadoresultado.idEmpresa}/${f1}/${f2}/${sucursalId}/${unidadId}/ReportEstadoResultado?repetirEncabezado=${repetirencabezado.Valor}&niveles=${nivelesEncoded}`;
            console.log('🔗 URL Estado de Resultado:', url);

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/pdf'
                }
            });

            if (response.ok) {
                const blob = await response.blob();
                const urlBlob = window.URL.createObjectURL(blob);
                
                const nombreArchivo = `Reporte_EstadoResultado_${idEmpresaEstadoresultado.nombreCompleto}_${f1}_${f2}.pdf`;
                setPdfUrl(urlBlob);
                setPdfNombre(nombreArchivo);
                setTipoReporte('estadoresultado');
                setOpenModal(true);

                Swal.fire('Éxito', 'Reporte de estado de resultados generado correctamente', 'success');
            } else {
                // Manejar errores específicos del servidor
                let errorMessage = 'No se pudo generar el reporte de estado de resultados';
                
                if (response.status === 400) {
                    errorMessage = 'Error en los parámetros enviados. Verifique la información seleccionada.';
                } else if (response.status === 500) {
                    try {
                        const errorText = await response.text();
                        if (errorText.includes('No hay datos para este informe')) {
                            errorMessage = 'No hay datos contables disponibles para los parámetros seleccionados (empresa, sucursal, unidad de negocio y rango de fechas).';
                        } else {
                            errorMessage = 'Error interno del servidor. Contacte al administrador.';
                        }
                    } catch (e) {
                        errorMessage = 'Error interno del servidor. Contacte al administrador.';
                    }
                }
                
                Swal.fire('Error', errorMessage, 'error');
            }
        } catch (error) {
            console.error('Error al generar reporte de estado de resultados:', error);
            Swal.fire('Error', 'Error de conexión. Verifique su conexión a internet e intente nuevamente.', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Cerrar modal
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    // Descargar PDF
    const handleDownloadPdf = () => {
        if (pdfUrl && pdfNombre) {
            const link = document.createElement('a');
            link.href = pdfUrl;
            link.download = pdfNombre;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            Swal.fire('Éxito', 'PDF descargado correctamente', 'success');
        }
    };

    // Descargar Excel desde el modal
    const handleDownloadExcelFromModal = () => {
        switch(tipoReporte) {
            case 'asientos':
                descargarAsientosExcel();
                break;
            case 'libromayor':
                descargarLibroMayorExcel();
                break;
            case 'balanza':
                descargarBalanzaComprobacionExcel();
                break;
            case 'balance':
                descargarBalanceGeneralExcel();
                break;
            case 'estadoresultado':
                descargarEstadoResultadoExcel();
                break;
            default:
                Swal.fire('Error', 'No se pudo determinar el tipo de reporte', 'error');
        }
    };

    // Funciones para descargar Excel
    const descargarAsientosExcel = async () => {
        if (!idEmpresaAsientos || !fechaInicioAsientos || !fechaFinAsientos) {
            Swal.fire('Error', 'Por favor complete todos los campos requeridos', 'error');
            return;
        }

        // Convertir fechas a formato YYYYMMDD
        const f1 = fechaInicioAsientos.replace(/-/g, '');
        const f2 = fechaFinAsientos.replace(/-/g, '');

        setLoading(true);
        try {
            const url = `${server}/InformesContablesExportExcel/asientos/${idEmpresaAsientos.idEmpresa}/${f1}/${f2}/ReportAsiento`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${user.token}`
                }
            });

            if (!response.ok) throw new Error('Error al generar el archivo Excel');

            const blob = await response.blob();
            const urlBlob = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlBlob;
            link.download = `Reporte_Asientos_${idEmpresaAsientos.nombreCompleto}_${f1}_${f2}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urlBlob);
            Swal.fire('Éxito', 'Archivo Excel descargado correctamente', 'success');
        } catch (error) {
            console.error('Error:', error);
            Swal.fire('Error', 'Error al descargar el archivo Excel', 'error');
        } finally {
            setLoading(false);
        }
    };

    const descargarLibroMayorExcel = async () => {
        if (!codigoCuentaMayor || !idCuentaMayor || !fechaInicioMayor || !fechaFinMayor) {
            Swal.fire('Error', 'Por favor complete todos los campos requeridos', 'error');
            return;
        }

        // Convertir fechas a formato YYYYMMDD
        const f1 = fechaInicioMayor.replace(/-/g, '');
        const f2 = fechaFinMayor.replace(/-/g, '');

        setLoading(true);
        try {
            const repetir = repetirencabezado.Valor ? 'true' : 'false';
            const url = `${server}/InformesContablesExportExcel/libromayor/${codigoCuentaMayor}/${idCuentaMayor}/${f1}/${f2}/${repetir}/ReportLibroMayor`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${user.token}`
                }
            });

            if (!response.ok) throw new Error('Error al generar el archivo Excel');

            const blob = await response.blob();
            const urlBlob = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlBlob;
            link.download = `Libro_Mayor_${codigoCuentaMayor}_${f1}_${f2}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urlBlob);
            Swal.fire('Éxito', 'Archivo Excel descargado correctamente', 'success');
        } catch (error) {
            console.error('Error:', error);
            Swal.fire('Error', 'Error al descargar el archivo Excel', 'error');
        } finally {
            setLoading(false);
        }
    };

    const descargarBalanzaComprobacionExcel = async () => {
        if (!idEmpresaBalanza || !fechaInicioBalanza || !fechaFinBalanza) {
            Swal.fire('Error', 'Por favor complete todos los campos requeridos', 'error');
            return;
        }

        // Convertir fechas a formato YYYYMMDD
        const f1 = fechaInicioBalanza.replace(/-/g, '');
        const f2 = fechaFinBalanza.replace(/-/g, '');

        setLoading(true);
        try {
            const url = `${server}/InformesContablesExportExcel/balanzacomprobacion/${idEmpresaBalanza.idEmpresa}/${f1}/${f2}/ReportBalanzaComprobacion`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${user.token}`
                }
            });

            if (!response.ok) throw new Error('Error al generar el archivo Excel');

            const blob = await response.blob();
            const urlBlob = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlBlob;
            link.download = `Balanza_Comprobacion_${idEmpresaBalanza.nombreCompleto}_${f1}_${f2}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urlBlob);
            Swal.fire('Éxito', 'Archivo Excel descargado correctamente', 'success');
        } catch (error) {
            console.error('Error:', error);
            Swal.fire('Error', 'Error al descargar el archivo Excel', 'error');
        } finally {
            setLoading(false);
        }
    };

    const descargarBalanceGeneralExcel = async () => {
        if (!idEmpresaBalance || !fechaInicioBalance || !fechafinBalance) {
            Swal.fire('Error', 'Por favor complete todos los campos requeridos', 'error');
            return;
        }

        // Convertir fechas a formato YYYYMMDD
        const f1 = fechaInicioBalance.replace(/-/g, '');
        const f2 = fechafinBalance.replace(/-/g, '');

        setLoading(true);
        try {
            const url = `${server}/InformesContablesExportExcel/balancegeneral/${idEmpresaBalance.idEmpresa}/${f1}/${f2}/ReportBalanceGeneral`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${user.token}`
                }
            });

            if (!response.ok) throw new Error('Error al generar el archivo Excel');

            const blob = await response.blob();
            const urlBlob = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlBlob;
            link.download = `Balance_General_${idEmpresaBalance.nombreCompleto}_${f1}_${f2}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urlBlob);
            Swal.fire('Éxito', 'Archivo Excel descargado correctamente', 'success');
        } catch (error) {
            console.error('Error:', error);
            Swal.fire('Error', 'Error al descargar el archivo Excel', 'error');
        } finally {
            setLoading(false);
        }
    };

    const descargarEstadoResultadoExcel = async () => {
        if (!idEmpresaEstadoresultado || !fechaInicioEstadoresultado || !fechafinEstadoresultado || !idSucursales || !idunidadNegocio) {
            Swal.fire('Error', 'Por favor complete todos los campos requeridos', 'error');
            return;
        }

        // Validar que los objetos tengan los IDs necesarios
        const sucursalId = idSucursales?.idSucursal || idSucursales?.id || idSucursales?.ID;
        const unidadId = idunidadNegocio?.idUnidadNegocio || idunidadNegocio?.id || idunidadNegocio?.ID;
        
        if (!sucursalId) {
            Swal.fire('Error', 'La sucursal seleccionada no tiene un ID válido', 'error');
            return;
        }
        
        if (!unidadId) {
            Swal.fire('Error', 'La unidad de negocio seleccionada no tiene un ID válido', 'error');
            return;
        }

        // Convertir fechas a formato YYYYMMDD
        const f1 = fechaInicioEstadoresultado.replace(/-/g, '');
        const f2 = fechafinEstadoresultado.replace(/-/g, '');

        setLoading(true);
        try {
            const url = `${server}/InformesContablesExportExcel/estadoresultado/${idEmpresaEstadoresultado.idEmpresa}/${f1}/${f2}/${sucursalId}/${unidadId}/ReportEstadoResultado`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${user.token}`
                }
            });

            if (!response.ok) throw new Error('Error al generar el archivo Excel');

            const blob = await response.blob();
            const urlBlob = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlBlob;
            link.download = `Estado_Resultado_${idEmpresaEstadoresultado.nombreCompleto}_${f1}_${f2}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urlBlob);
            Swal.fire('Éxito', 'Archivo Excel descargado correctamente', 'success');
        } catch (error) {
            console.error('Error:', error);
            Swal.fire('Error', 'Error al descargar el archivo Excel', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="right_col" role="main">
            <div className="x_panel">
                <div className="x_title">
                    <h2>
                        <AssessmentIcon style={{ marginRight: 10, verticalAlign: 'middle' }} />
                        Informes Financieros
                    </h2>
                    <div className="clearfix"></div>
                </div>
                <div className="x_content">
                    <Paper elevation={3}>
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            centered
                            sx={{ borderBottom: 1, borderColor: 'divider' }}
                        >
                            <Tab 
                                icon={<DescriptionIcon />} 
                                label="Reporte de Asientos" 
                                iconPosition="start"
                            />
                            <Tab 
                                icon={<AssessmentIcon />} 
                                label="Libro Mayor" 
                                iconPosition="start"
                            />
                            <Tab 
                                icon={<AssessmentIcon />} 
                                label="Balanza de Comprobación" 
                                iconPosition="start"
                            />
                            <Tab 
                                icon={<Balance />} 
                                label="Estado de Situación Financiera" 
                                iconPosition="start"
                            />
                          
                             <Tab 
                                icon={<Money/>} 
                                label="Estado de Resultado" 
                                iconPosition="start"
                            />
                            </Tabs>

                        {/* Tab Panel 1: Reporte de Asientos */}
                        <TabPanel value={tabValue} index={0}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" gutterBottom color="primary">
                                        Reporte de Asientos Contables
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" paragraph>
                                        Genere un reporte de todos los asientos contables registrados en un rango de fechas específico.
                                    </Typography>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                value={idEmpresaAsientos}
                                                onChange={(event, newValue) => {
                                                    setIdEmpresaAsientos(newValue);
                                                }}
                                                options={empresas}
                                                getOptionLabel={(option) => option.nombreCompleto || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Empresa *"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li {...props} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                        {option.nombreCompleto}
                                                    </li>
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Fecha Inicio *"
                                                type="date"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                value={fechaInicioAsientos}
                                                onChange={(e) => setFechaInicioAsientos(e.target.value)}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Fecha Fin *"
                                                type="date"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                value={fechaFinAsientos}
                                                onChange={(e) => setFechaFinAsientos(e.target.value)}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <PrintIcon />}
                                                    onClick={generarReporteAsientos}
                                                    disabled={loading || !tienePermiso('Generar Informe Financiero')}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {loading ? 'Generando...' : 'Generar PDF'}
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="large"
                                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <InsertDriveFileIcon />}
                                                    onClick={descargarAsientosExcel}
                                                    disabled={loading || !tienePermiso('Generar Informe Financiero')}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {loading ? 'Descargando...' : 'Descargar Excel'}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    <Alert severity="info" sx={{ mt: 3 }}>
                                        <strong>Formato de fechas:</strong> AAAA-MM-DD (ejemplo: 2025-10-20)
                                    </Alert>
                                </CardContent>
                            </Card>
                        </TabPanel>

                        {/* Tab Panel 2: Libro Mayor */}
                        <TabPanel value={tabValue} index={1}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" gutterBottom color="primary">
                                        Libro Mayor
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" paragraph>
                                        Genere el libro mayor para una cuenta contable de detalle (nivel 5 - cuentas que aceptan movimientos).
                                    </Typography>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                value={cuentasMayor.find(c => c.codigo === codigoCuentaMayor) || null}
                                                onChange={(event, newValue) => {
                                                    if (newValue) {
                                                        setCodigoCuentaMayor(newValue.codigo);
                                                        setIdCuentaMayor(newValue.idCuenta);
                                                    } else {
                                                        setCodigoCuentaMayor(null);
                                                        setIdCuentaMayor(null);
                                                    }
                                                }}
                                                options={cuentasMayor}
                                                getOptionLabel={(option) => 
                                                    `${option.codigo} - ${option.descripcion}`
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Cuenta de Detalle (N5) *"
                                                        variant="outlined"
                                                        fullWidth
                                                        helperText={`${cuentasMayor.length} cuentas de detalle disponibles (Nivel 5)`}
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li {...props} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                        <Box>
                                                            <Typography variant="body1" component="div">
                                                                <strong>{option.codigo}</strong>
                                                            </Typography>
                                                            <Typography variant="body2" color="textSecondary">
                                                                {option.descripcion}
                                                            </Typography>
                                                        </Box>
                                                    </li>
                                                )}
                                                sx={{ minWidth: 350 }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Fecha Inicio *"
                                                type="date"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                value={fechaInicioMayor}
                                                onChange={(e) => setFechaInicioMayor(e.target.value)}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Fecha Fin *"
                                                type="date"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                value={fechaFinMayor}
                                                onChange={(e) => setFechaFinMayor(e.target.value)}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Repetir Encabezado
                                            </Typography>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={repetirencabezado.Valor}
                                                            onChange={(e) =>
                                                                setRepetirEncabezado(prev => ({ ...prev, Valor: e.target.checked }))
                                                            }
                                                        />
                                                    }
                                                    label="Repetir encabezado en cada página"
                                                />
                                            </FormGroup>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <PrintIcon />}
                                                    onClick={generarLibroMayor}
                                                    disabled={loading || !tienePermiso('Generar Informe Financiero')}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {loading ? 'Generando...' : 'Generar PDF'}
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="large"
                                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <InsertDriveFileIcon />}
                                                    onClick={descargarLibroMayorExcel}
                                                    disabled={loading || !tienePermiso('Generar Informe Financiero')}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {loading ? 'Descargando...' : 'Descargar Excel'}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    <Alert severity="info" sx={{ mt: 3 }}>
                                        <strong>Formato de fechas:</strong> AAAA-MM-DD (ejemplo: 2025-10-20)
                                        <br />
                                        <strong>Nota:</strong> Solo se pueden consultar cuentas de detalle (Nivel 5) que aceptan movimientos.
                                    </Alert>
                                </CardContent>
                            </Card>
                        </TabPanel>
                        
                        {/* Tab Panel 3: Balanza de Comprobación */}
                        <TabPanel value={tabValue} index={2}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" gutterBottom color="primary">
                                        Balanza de Comprobación
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" paragraph>
                                        Genere la balanza de comprobación de una empresa en un rango de fechas específico.
                                    </Typography>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                value={idEmpresaBalanza}
                                                onChange={(event, newValue) => {
                                                    setIdEmpresaBalanza(newValue);
                                                }}
                                                options={empresas}
                                                getOptionLabel={(option) => option.nombreCompleto || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Empresa *"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li {...props} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                        {option.nombreCompleto}
                                                    </li>
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Fecha Inicio *"
                                                type="date"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                value={fechaInicioBalanza}
                                                onChange={(e) => setFechaInicioBalanza(e.target.value)}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Fecha Fin *"
                                                type="date"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                value={fechaFinBalanza}
                                                onChange={(e) => setFechaFinBalanza(e.target.value)}
                                            />
                                        </Grid>
     
                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <PrintIcon />}
                                                    onClick={generarBalanzaComprobacion}
                                                    disabled={loading || !tienePermiso('Generar Informe Financiero')}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {loading ? 'Generando...' : 'Generar PDF'}
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="large"
                                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <InsertDriveFileIcon />}
                                                    onClick={descargarBalanzaComprobacionExcel}
                                                    disabled={loading || !tienePermiso('Generar Informe Financiero')}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {loading ? 'Descargando...' : 'Descargar Excel'}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    <Alert severity="info" sx={{ mt: 3 }}>
                                        <strong>Formato de fechas:</strong> AAAA-MM-DD (ejemplo: 2025-10-20)
                                    </Alert>
                                </CardContent>
                            </Card>
                        </TabPanel>

                        {/* Tab Panel 4: Estado de Situación Financiera */}
                        <TabPanel value={tabValue} index={3}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" gutterBottom color="primary">
                                        Estado de Situación Financiera
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" paragraph>
                                        Genere el reporte completo del Estado de Situación Financiera de la empresa
                                    </Typography>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                value={idEmpresaBalance}
                                                onChange={(event, newValue) => {
                                                    setIdEmpresaBalance(newValue);
                                                }}
                                                options={empresas}
                                                getOptionLabel={(option) => option.nombreCompleto || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Empresa *"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li {...props} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                        {option.nombreCompleto}
                                                    </li>
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Fecha Inicio *"
                                                type="date"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                value={fechaInicioBalance}
                                                onChange={(e) => setFechaInicioBalance(e.target.value)}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Fecha Fin *"
                                                type="date"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                value={fechafinBalance}
                                                onChange={(e) => setFechaFinBalance(e.target.value)}
                                            />
                                        </Grid>
                                    {/* 👇 NUEVO BLOQUE: selección de niveles */}
                                            <Grid item xs={12} md={6}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Niveles a incluir en el Estado de Situación Financiera
                                                </Typography>
                                                <FormGroup row>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={nivelesBalance.Nivel1}
                                                                onChange={(e) =>
                                                                    setNivelesBalance(prev => ({ ...prev, Nivel1: e.target.checked }))
                                                                }
                                                            />
                                                        }
                                                        label="Nivel 1"
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={nivelesBalance.Nivel2}
                                                                onChange={(e) =>
                                                                    setNivelesBalance(prev => ({ ...prev, Nivel2: e.target.checked }))
                                                                }
                                                            />
                                                        }
                                                        label="Nivel 2"
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={nivelesBalance.Nivel3}
                                                                onChange={(e) =>
                                                                    setNivelesBalance(prev => ({ ...prev, Nivel3: e.target.checked }))
                                                                }
                                                            />
                                                        }
                                                        label="Nivel 3"
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={nivelesBalance.Nivel4}
                                                                onChange={(e) =>
                                                                    setNivelesBalance(prev => ({ ...prev, Nivel4: e.target.checked }))
                                                                }
                                                            />
                                                        }
                                                        label="Nivel 4"
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={nivelesBalance.Detalle}
                                                                onChange={(e) =>
                                                                    setNivelesBalance(prev => ({ ...prev, Detalle: e.target.checked }))
                                                                }
                                                            />
                                                        }
                                                        label="Detalle"
                                                    />
                                                </FormGroup>
                                            </Grid>

                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <PrintIcon />}
                                                    onClick={generarBalanceGeneral}
                                                    disabled={loading || !tienePermiso('Generar Informe Financiero')}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {loading ? 'Generando...' : 'Generar PDF'}
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="large"
                                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <InsertDriveFileIcon />}
                                                    onClick={descargarBalanceGeneralExcel}
                                                    disabled={loading || !tienePermiso('Generar Informe Financiero')}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {loading ? 'Descargando...' : 'Descargar Excel'}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    <Alert severity="info" sx={{ mt: 3 }}>
                                        <strong>Formato de fechas:</strong> AAAA-MM-DD (ejemplo: 2025-10-20)
                                    </Alert>
                                </CardContent>
                            </Card>
                        </TabPanel>                          

                        {/* Tab Panel 5: Estado de resultado */}
                   
                        <TabPanel value={tabValue} index={4}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="h6" gutterBottom color="primary">
                                        Reporte de Estados de Resultados
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" paragraph>
                                        Genere el reporte de Estado de Resultados por Empresa, Sucursal y Unidad de Negocio
                                    </Typography>

                                    <Grid container spacing={3}>
                                        <Grid item xs={4}>
                                            <Autocomplete
                                                value={idEmpresaEstadoresultado}
                                                onChange={(event, newValue) => {
                                                    setidEmpresaEstadoresultado(newValue);
                                                }}
                                                options={empresas}
                                                getOptionLabel={(option) => option.nombreCompleto || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Empresa *"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li {...props} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                        {option.nombreCompleto}
                                                    </li>
                                                )}
                                            />
                                        </Grid>
                                         <Grid item xs={4}>
                                            <Autocomplete
                                                value={idSucursales}
                                                onChange={(event, newValue) => {
                                                    setIdSucursales(newValue);
                                                }}
                                                options={sucursalesFiltradas}
                                                getOptionLabel={(option) => option?.nombreSucursal || ''}
                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                disabled={!idEmpresaEstadoresultado || sucursalesFiltradas.length === 0}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Sucursal *"
                                                        variant="outlined"
                                                        fullWidth
                                                        helperText={
                                                            !idEmpresaEstadoresultado 
                                                                ? "Seleccione primero una empresa"
                                                                : sucursalesFiltradas.length === 0 
                                                                    ? "No hay sucursales para esta empresa"
                                                                    : `${sucursalesFiltradas.length} sucursal(es) disponible(s)`
                                                        }
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li {...props} key={option.id} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                        {option.nombreSucursal}
                                                    </li>
                                                )}
                                            />
                                        </Grid>
                                              <Grid item xs={4}>
                                            <Autocomplete
                                                value={idunidadNegocio}
                                                onChange={(event, newValue) => {
                                                    setIdUnidadNegocio(newValue);
                                                }}
                                                options={unidaddenegocio}
                                                getOptionLabel={(option) => option.unidadNegocio || ''}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Unidad de Negocio *"
                                                        variant="outlined"
                                                        fullWidth
                                                    />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li {...props} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                                                        {option.unidadNegocio}
                                                    </li>
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Fecha Inicio *"
                                                type="date"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                value={fechaInicioEstadoresultado}
                                                onChange={(e) => setfechaInicioEstadoresultado(e.target.value)}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                label="Fecha Fin *"
                                                type="date"
                                                fullWidth
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                                value={fechafinEstadoresultado}
                                                onChange={(e) => setfechafinEstadoresultado(e.target.value)}
                                            />
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Niveles a mostrar
                                            </Typography>
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={nivelesEstadoResultado.Nivel1}
                                                            onChange={(e) =>
                                                                setNivelesEstadoResultado(prev => ({ ...prev, Nivel1: e.target.checked }))
                                                            }
                                                        />
                                                    }
                                                    label="Nivel 1"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={nivelesEstadoResultado.Nivel2}
                                                            onChange={(e) =>
                                                                setNivelesEstadoResultado(prev => ({ ...prev, Nivel2: e.target.checked }))
                                                            }
                                                        />
                                                    }
                                                    label="Nivel 2"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={nivelesEstadoResultado.Nivel3}
                                                            onChange={(e) =>
                                                                setNivelesEstadoResultado(prev => ({ ...prev, Nivel3: e.target.checked }))
                                                            }
                                                        />
                                                    }
                                                    label="Nivel 3"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={nivelesEstadoResultado.Nivel4}
                                                            onChange={(e) =>
                                                                setNivelesEstadoResultado(prev => ({ ...prev, Nivel4: e.target.checked }))
                                                            }
                                                        />
                                                    }
                                                    label="Nivel 4"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={nivelesEstadoResultado.Detalle}
                                                            onChange={(e) =>
                                                                setNivelesEstadoResultado(prev => ({ ...prev, Detalle: e.target.checked }))
                                                            }
                                                        />
                                                    }
                                                    label="Detalle"
                                                />
                                            </FormGroup>
                                        </Grid>
                                   
                                            <Grid item xs={4} md={2}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Repetir Encabezado
                                                </Typography>
                                                <FormGroup row>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={repetirencabezado.Valor}
                                                                onChange={(e) =>
                                                                    setRepetirEncabezado(prev => ({ ...prev, Valor: e.target.checked }))
                                                                }
                                                            />
                                                        }
                                                        label="Si"
                                                    />
                                                   
                                                </FormGroup>
                                            </Grid>

                                        <Grid item xs={12}>
                                            <Box display="flex" justifyContent="center" gap={2} mt={2}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="large"
                                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <PrintIcon />}
                                                    onClick={generarEstadoResultado}
                                                    disabled={loading || !tienePermiso('Generar Informe Financiero')}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {loading ? 'Generando...' : 'Generar PDF'}
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="large"
                                                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <InsertDriveFileIcon />}
                                                    onClick={descargarEstadoResultadoExcel}
                                                    disabled={loading || !tienePermiso('Generar Informe Financiero')}
                                                    sx={{ minWidth: 200 }}
                                                >
                                                    {loading ? 'Descargando...' : 'Descargar Excel'}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    <Alert severity="info" sx={{ mt: 3 }}>
                                        <strong>Formato de fechas:</strong> AAAA-MM-DD (ejemplo: 2025-10-20)
                                    </Alert>
                                </CardContent>
                            </Card>
                        </TabPanel>     

                    </Paper>
                </div>
            </div>

            {/* Modal para visualizar PDF */}
            <Modal open={openModal} onClose={handleCloseModal}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90%',
                        height: '90vh',
                        bgcolor: 'white',
                        boxShadow: 24,
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden'
                    }}
                >
                    {/* Header del modal */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            p: 2,
                            borderBottom: '1px solid #ddd',
                            bgcolor: '#f5f5f5'
                        }}
                    >
                        <Typography variant="h6" component="h2">
                            {pdfNombre}
                        </Typography>
                        <Box>
                            <IconButton
                                onClick={handleDownloadPdf}
                                color="primary"
                                title="Descargar PDF"
                                sx={{ mr: 1 }}
                            >
                                <DownloadIcon />
                            </IconButton>
                            <IconButton
                                onClick={handleDownloadExcelFromModal}
                                sx={{ mr: 1, color: '#2e7d32' }}
                                title="Descargar Excel"
                            >
                                <InsertDriveFileIcon />
                            </IconButton>
                            <IconButton
                                onClick={handleCloseModal}
                                color="error"
                                title="Cerrar"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    {/* Contenedor del PDF */}
                    <Box
                        sx={{
                            flex: 1,
                            overflow: 'hidden',
                            bgcolor: '#525659'
                        }}
                    >
                        {pdfUrl && (
                            <iframe
                                src={pdfUrl}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 'none'
                                }}
                                title="Visor de PDF"
                            />
                        )}
                    </Box>

                    {/* Footer del modal */}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            p: 2,
                            borderTop: '1px solid #ddd',
                            bgcolor: '#f5f5f5'
                        }}
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleDownloadPdf}
                                startIcon={<DownloadIcon />}
                            >
                                Descargar PDF
                            </Button>
                            <Button
                                variant="contained"
                                sx={{ bgcolor: '#2e7d32', '&:hover': { bgcolor: '#1b5e20' } }}
                                onClick={handleDownloadExcelFromModal}
                                startIcon={<InsertDriveFileIcon />}
                            >
                                Descargar Excel
                            </Button>
                        </Box>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={handleCloseModal}
                            startIcon={<CloseIcon />}
                        >
                            Cerrar
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
}

export default InformesFinancieros;
